import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold text-gray-800" }, "Participants", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, " You can access participants’ Raise accounts to help fundraise more. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1)
const _hoisted_5 = {
  role: "list",
  class: "gap-3 grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 2xl:grid-cols-5"
}
const _hoisted_6 = { class: "md:mt-2 flex-1 self-center text-left md:text-center" }
const _hoisted_7 = { class: "text-gray-800 font-medium leading-4" }
const _hoisted_8 = {
  key: 0,
  class: "p-4 overflow-hidden text-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold text-gray-800" }, "Guardians", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1)
const _hoisted_11 = {
  role: "list",
  class: "gap-3 grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 2xl:grid-cols-5"
}
const _hoisted_12 = { class: "md:mt-2 flex-1 self-center text-left md:text-center" }
const _hoisted_13 = { class: "text-gray-800 font-medium leading-4 md:mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_snap_dropdown = _resolveComponent("snap-dropdown")!
  const _component_snap_avatar = _resolveComponent("snap-avatar")!
  const _component_snap_button = _resolveComponent("snap-button")!
  const _component_snap_icon = _resolveComponent("snap-icon")!
  const _component_PageSection = _resolveComponent("PageSection")!
  const _component_Link = _resolveComponent("Link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$apollo.loading)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 0,
          class: "w-10 h-10 mx-auto my-10"
        }))
      : _createCommentVNode("", true),
    (!_ctx.$apollo.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_PageSection, null, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: child.id as string,
                    class: _normalizeClass(["relative bg-white p-4 border border-gray-200 rounded-lg text-center flex gap-3 md:block", {
            'opacity-50': child.isDisabled || !_ctx.canImpersonateChild(child),
          }])
                  }, [
                    (_ctx.canManageChildren)
                      ? (_openBlock(), _createBlock(_component_snap_dropdown, {
                          key: 0,
                          class: "absolute top-1 right-1",
                          minimal: "",
                          ".options": _ctx.childMenuOptions(child),
                          onSnapDropdownItemSelected: _ctx.onChildMenuItemSelected,
                          "track-current-selection": "false",
                          "modal-type": "drawer"
                        }, null, 40, [".options", "onSnapDropdownItemSelected"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_snap_avatar, {
                      "image-src": child.profilePicture || '',
                      "avatar-link": "javascript:void(0)",
                      size: "profile",
                      class: "inline-block"
                    }, null, 8, ["image-src"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(child.fullName), 1),
                      (_ctx.canImpersonateChild(child))
                        ? (_openBlock(), _createBlock(_component_snap_button, {
                            key: 0,
                            variant: "primary",
                            size: "sm",
                            "full-width": "",
                            onClick: ($event: any) => (_ctx.canImpersonateChild(child) && _ctx.impersonate(child, true)),
                            class: "mt-2",
                            title: _ctx.helpFundraiseLink
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Help Fundraise ")
                            ]),
                            _: 2
                          }, 1032, ["onClick", "title"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128)),
                (_ctx.canManageChildren)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "w-24 h-24 rounded-full bg-gray-100",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('child:create')))
                      }, [
                        _createVNode(_component_snap_icon, {
                          icon: "user-add-solid",
                          size: "xl"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_ctx.parents.length > 0)
            ? (_openBlock(), _createBlock(_component_PageSection, { key: 0 }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parents, (parent) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: parent.id as string,
                        class: _normalizeClass(["relative bg-white p-4 border border-gray-200 rounded-lg text-center flex gap-3 md:block", {
            'opacity-50': parent.isDisabled,
          }])
                      }, [
                        _createVNode(_component_snap_avatar, {
                          "image-src": parent.profilePicture || '',
                          "avatar-link": "javascript:void(0)",
                          size: "profile",
                          class: "inline-block"
                        }, null, 8, ["image-src"]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("p", _hoisted_13, _toDisplayString(parent.fullName), 1),
                          (_ctx.isItMe(parent))
                            ? (_openBlock(), _createBlock(_component_Link, {
                                key: 0,
                                to: { name: 'home' }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Edit Profile ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}